/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import {
  Layout,
  Table,
  Input,
  DatePicker,
  Button,
  Switch,
  Typography,
  Modal,
  message,
  Card,
  Row,
  Col,
  Space,
  Popconfirm,
  Form,
} from "antd";
import dayjs from "dayjs";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import axios from "axios";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import {
  CHANEL_SYNC_INVENTORY,
  CHANEL_SYNC_NO_SHOW,
  CHANEL_SYNC_RATE,
  RATE_PLAN,
  RATE_PLAN_CREATE,
  RATE_PLAN_EDIT,
  RATE_PLAN_TRUNCATE,
  RATE_PLAN_UPDATE,
} from "../../constants/api";
import {
  ERROR_MSG_TYPE,
  SUCCESS_MSG_TYPE,
  WARNING_MSG_TYPE,
} from "../../constants/messages";

const { Content } = Layout;
const { Title } = Typography;
const { RangePicker } = DatePicker;

function RatePlan() {
  const [dates, setDates] = useState([]);
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [fetchRange, setFetchRange] = useState([
    dayjs().startOf("day"),
    dayjs().add(6, "day").endOf("day"),
  ]);

  const [range, setRange] = useState([
    dayjs().startOf("day"),
    dayjs().add(6, "day").endOf("day"),
  ]);

  useEffect(() => {
    fetchRatePlans();
  }, [fetchRange]);

  const fetchRatePlans = async () => {
    setLoading(true);
    postAPI(
      RATE_PLAN,
      {
        start_date: fetchRange[0].format("YYYY-MM-DD"),
        end_date: fetchRange[1].format("YYYY-MM-DD"),
      },
      (res) => {
        if(!res.status){
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, res.message);
          return;
        }
        setDates(res.dates);

        const transformedRates = res.rates.map((item) => {
          const rateRow = {
            key: item.detail.id,
            room_id: item.detail.room_id,
            room_no: item.detail.room.room_no,
            category: item.detail.room_code,
            planCode: item.detail.rate_plan_code,
            dates: {},
          };

          item.rates.forEach((rateObj) => {
            rateRow.dates[rateObj.date] = rateObj.rate;
          });

          return rateRow;
        });

        setRates(transformedRates);
        setLoading(false);

        if (res.rates.length === 0) {
          setRange([dayjs().startOf("day"), dayjs().endOf("year")]);
          setModalVisible(true);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to fetch rate plans");
      }
    );
  };

  const handleRateChange = (value, dateKey, planKey) => {
    setRates((prev) =>
      prev.map((row) => {
        if (row.key === planKey) {
          return {
            ...row,
            dates: {
              ...row.dates,
              [dateKey]: value,
            },
          };
        }
        return row;
      })
    );
  };

  const handleUpdateRate = async () => {
    setLoading(true);
    postAPI(
      RATE_PLAN_UPDATE,
      { body: rates },
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
          setModalVisible(false);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to update rates");
      }
    );
  };

  const handleEditRate = async (values) => {
    const body = {
      values: values,
      start_date: values.dates[0].format("YYYY-MM-DD"),
      end_date: values.dates[1].format("YYYY-MM-DD"),
    };
    delete body.values.dates;

    setLoading(true);
    postAPI(
      RATE_PLAN_EDIT,
      body,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          form.resetFields();
          fetchRatePlans();
          setEditModalVisible(false);
        } else {
          form.resetFields();
          fetchRatePlans();
          setEditModalVisible(false);
          displayMessage(WARNING_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to edit dates");
      }
    );
  };

  const handleCreateDates = async () => {
    setLoading(true);
    postAPI(
      RATE_PLAN_CREATE,
      {
        start_date: range[0].format("YYYY-MM-DD"),
        end_date: range[1].format("YYYY-MM-DD"),
      },
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
          setModalVisible(false);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to generate dates");
      }
    );
  };

  const syncRateToOTA = async () => {
    setLoading(true);
    getAPI(
      CHANEL_SYNC_RATE,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
        } else {
          displayMessage(WARNING_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to Sync-Rate-Plan to OTA");
      }
    );
  };

  const handleTruncate = async () => {
    setLoading(true);
    getAPI(
      RATE_PLAN_TRUNCATE,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to clear plans");
      }
    );
  };

  const syncInvToOTA = async () => {
    setLoading(true);
    postAPI(
      CHANEL_SYNC_INVENTORY,
      {},
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
        } else {
          displayMessage(WARNING_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to Sync-Inventory to OTA");
      }
    );
  };

  const syncNoShowToOTA = async () => {
    setLoading(true);
    getAPI(
      CHANEL_SYNC_NO_SHOW,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchRatePlans();
        } else {
          displayMessage(WARNING_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to Sync-NoShow to OTA");
      }
    );
  };

  const columns = [
    {
      title: "Room Code",
      dataIndex: "category",
      key: "category",
      fixed: "left",
      width: 180,
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Rate Plan Code",
      dataIndex: "planCode",
      key: "planCode",
      width: 150,
    },
    {
      title: "Room No",
      dataIndex: "room_no",
      key: "room_no",
      width: 150,
    },
    ...dates.map((dateStr) => ({
      title: (
        <div style={{ textAlign: "center" }}>
          <div>{dayjs(dateStr).format("ddd")}</div>
          <div>{dayjs(dateStr).format("DD MMM")}</div>
        </div>
      ),
      key: dateStr,
      width: 120,
      render: (value, row) => (
        <Input
          value={row.dates ? row.dates[dateStr] : ""}
          type="number"
          onChange={(e) => handleRateChange(e.target.value, dateStr, row.key)}
        />
      ),
    })),
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content className="p-4 bg-white min-h-screen">
        <Card
          title="Rates & Inventory"
          extra={
            <>
              <Space>
                <RangePicker
                  loading={loading}
                  disabled={loading}
                  value={fetchRange}
                  onChange={setFetchRange}
                  format="DD-MM-YYYY"
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                />
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={handleUpdateRate}
                >
                  Update And Sync
                </Button>
                {rates.length > 0 ? (
                  <Button
                    loading={loading}
                    disabled={loading}
                    type="primary"
                    onClick={() => setEditModalVisible(true)}
                  >
                    Bulk Update
                  </Button>
                ) : (
                  <></>
                )}
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={() => setModalVisible(true)}
                >
                  Re-Generate
                </Button>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={fetchRatePlans}
                >
                  Refresh
                </Button>
                <Popconfirm
                  title="Truncate the Rate Plan"
                  description="Are you sure you want to clear all rate plans? This action cannot be undone."
                  okText="Yes"
                  cancelText="No"
                  onConfirm={handleTruncate}
                >
                  <Button
                    danger
                    loading={loading}
                    disabled={loading}
                    style={{ color: "#fff" }}
                  >
                    Truncate Plans
                  </Button>
                </Popconfirm>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={syncRateToOTA}
                >
                  Manual Sync-Rate-OTA
                </Button>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={syncInvToOTA}
                >
                  Manual Sync-Inventory-OTA
                </Button>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={syncNoShowToOTA}
                >
                  Manual Sync-NoShow-OTA
                </Button>
              </Space>
            </>
          }
        >
          {rates.length > 0 ? (
            <Table
              loading={loading}
              dataSource={rates}
              columns={columns}
              bordered
              scroll={{ x: "max-content" }}
              pagination={false}
              rowClassName={() => "align-middle"}
            />
          ) : (
            <Row gutter={[16, 16]} justify={"center"}>
              <Col>
                <Button
                  loading={loading}
                  disabled={loading}
                  type="primary"
                  onClick={() => setModalVisible(true)}
                >
                  Generate for this Year
                </Button>
              </Col>
            </Row>
          )}
        </Card>
        <Modal
          loading={loading}
          disabled={loading}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          onOk={handleCreateDates}
          title="Create Rate Plan Data"
        >
          <p>No rate plan data found for the next 7 days. Please create it.</p>
          <RangePicker
            value={range}
            onChange={(value) => setRange(value)}
            format="DD-MM-YYYY"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current < dayjs().startOf("day")
            }
          />
        </Modal>
        <Modal
          loading={loading}
          disabled={loading}
          open={editModalVisible}
          onCancel={() => setEditModalVisible(false)}
          onOk={() => form.submit()}
          title="Update Bulk Plan Data"
          onClose={form.resetFields}
        >
          <Form form={form} layout="vertical" onFinish={handleEditRate}>
            <Form.Item name="dates" rules={[{ required: true }]}>
              <RangePicker
                value={range}
                onChange={(value) => setRange(value)}
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />
            </Form.Item>

            {rates.map((data) => {
              return (
                <>
                  <Form.Item name={data.planCode} label={data.planCode}>
                    <Input type="number" placeholder={data.planCode} />
                  </Form.Item>
                </>
              );
            })}
          </Form>
        </Modal>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default RatePlan;
